export const changePlanClicked = () => ({
  type: 'Change Plan Clicked',
});
